// extracted by mini-css-extract-plugin
module.exports = {"container":"_27aucBaeef5d-7sovhcg8F","restaurantsList":"_1i8GlozILCjhkup3FrMNpp","item":"_3WZ-2Nkn7chKJ0uqtwC6aw","dot":"zgo0jy4egq3jvkfn49J1G","input":"_1CtRaC0xcM3OBliskn9y_0"};